// src/services/notifications/strategies/EmailStrategy.js
//import { replacePlaceholders, emailTemplate } from './emailTemplate';
import { emailTemplates } from '@/services/notifications/templates/emailTemplates';



export class EmailStrategy {
  constructor() {
    this.apiBaseUrl = `${process.env.VUE_APP_API_URL}/send-email`;
    // console.log ("this.apiBaseUrl dentro de Constructor EmailStrategy", this.apiBaseUrl);
    //o endpoint da avalioo exige apikey
    this.apiKey = process.env.VUE_APP_API_KEY; // Nova variável de ambiente
  }


  async sendEmailTemplate(template, params, to) {
    const emailContent = emailTemplates[template](params);
    const finalHtml = emailTemplates.baseTemplate(emailContent.content);

    return this.send({
      to,
      subject: emailContent.subject,
      message: finalHtml
    });
  }


  async send(payload) {
    try {

      // const emailContent = replacePlaceholders(emailTemplate, {
      //   titleEmail: 'Confirmação de Cadastro',
      //   mainMessage: `Bem-vindo à nossa plataforma! Seu cadastro foi confirmado com sucesso.`,
      // });

      //const agora = new Date().toLocaleString('pt-BR') // Resultado: "10/12/2024 14:30:45"
      //let subject = "Teste em " + agora;


      // console.log ("this.apiBaseUrl dentro de async send(payload) em EmailStrategy", this.apiBaseUrl);
      //this.apiBaseUrl
      const response = await fetch(this.apiBaseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': this.apiKey // Adiciona API key em todas as requisições
        },
        body: JSON.stringify({
          to_email: payload.to,
          subject: payload.subject,
          html_content: payload.message
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Erro ao enviar email:', errorData);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao enviar email:', error);
      return false;
    }
  }
}